import { Container, Image, setData, useApiCallback, useDispatch, useSelector } from 'gf-ui'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PAGINE } from '..'
import apiQuestionario from '../../api/apiQuestionario'
import en from "../../assets/images/en.png"
import es from "../../assets/images/es.png"
import it from "../../assets/images/it.png"
import ospedale from '../../assets/images/ospedale.jpg'
import Footer from '../../components/Footer'
import PageContainer from '../../components/PageContainer'
import HeaderTicketPsStranieri from './components/HeaderTicketPsStranieri'
import "./HomeTicketPsStranieri.scss"

const LINGUE = {
    'it': 'Italiano',
    'en': 'English',
    'es': 'Español'
}

const HomeTicketPsStranieri = ({ tipologia }) => {
    const pageData = useSelector(state => state.page.data)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const apiCallback = useApiCallback()
    const _apiQuestionario = useRef(new apiQuestionario(dispatch, apiCallback, null))
    const [lingue, setLingue] = useState()

    const onSelLingua = (lingua) => {
        setData(dispatch, { ...pageData, LINGUA: lingua })
        navigate(`/${tipologia.URL}${PAGINE.QUESTIONARIO.URL(tipologia)}`)
    }

    useEffect(() => {
        _apiQuestionario.current.fnLingue(tipologia.KID, res => setLingue(res.lingue))
    }, [tipologia.KID])

    return <PageContainer tipologia={tipologia}>
        <Container className='home-container shadow border bg-white p-0 d-flex flex-column align-items-start justify-content-between'>

            <HeaderTicketPsStranieri subtitle="Questionario per la prevenzione del tumore del seno" />

            <div className='w-100'>
                <div className='text-center text-uppercase fw-bold text-primary'>
                    <h1 className='pt-4 text-center text-uppercase'>Ticket Pronto Soccorso - Stranieri</h1>
                    <h2 className='px-4 mb-0'>Seleziona una lingua</h2>
                    <h4 className='px-4 pb-4'>Select a language</h4>
                </div>

                <div style={{ background: "url(" + ospedale + ")" }} className='lingue'>
                    <div className='w-100 d-flex flex-row align-items-center justify-content-evenly flex-wrap'>
                        {lingue?.map(lingua =>
                            <div onClick={() => onSelLingua(lingua)}>
                                {lingua === 'it' && <div className='lingua-container'><Image src={it} className={`lingua lingua-${lingua} animate__animated animate__flipInX`} /><div className='lingua-nome'>{LINGUE[lingua]}</div></div>}
                                {lingua === 'en' && <div className='lingua-container'><Image src={en} className={`lingua lingua-${lingua} animate__animated animate__flipInX`} /><div className='lingua-nome'>{LINGUE[lingua]}</div></div>}
                                {lingua === 'es' && <div className='lingua-container'><Image src={es} className={`lingua lingua-${lingua} animate__animated animate__flipInX`} /><div className='lingua-nome'>{LINGUE[lingua]}</div></div>}
                            </div>
                        )}
                    </div>
                </div>

                <div className='bg-light p-4 text-center'>
                    <p>
                        Seleziona una lingua e compila il form con i tuoi dati per stampare la ricevuta ed effettuare il pagamento.
                    </p>
                    <p>
                        Select a language and fill out the form with your details to print the receipt and make the payment.
                    </p>
                </div>
            </div>

            <Footer tipologia={tipologia} />
        </Container>
    </PageContainer>
}

export default HomeTicketPsStranieri